/* eslint-disable @typescript-eslint/no-unsafe-return -- Contains a lazy loaded component */
import { memo } from 'react';

import { Builder, withChildren } from '@builder.io/react';
import dynamic from 'next/dynamic';

import { uiImages } from '@/react/components/content/registry/data';
import { target } from '../../../registry/data/parts/target';

/**
 * Register the AnchorTarget component.
 */
const register = (): void => {
  const component = memo(
    dynamic(
      async () => import(/* webpackChunkName: "AnchorTargetIndex" */ './index')
    )
  );
  const componentWithChildren = withChildren(component);

  Builder.registerComponent(componentWithChildren, {
    name: 'AnchorTarget',
    friendlyName: 'Anchor Target',
    description:
      'A component that serves as an anchor target. Will render a div with the specified ID, which can be used as a target for anchor links, just before the children.',
    canHaveChildren: true,
    inputs: [target],
    defaultChildren: [],
    image: uiImages.sectionImage
  });
};

export default register;
